import React from "react";
import PanelExtended, {PanelHeader} from "../../Common/Components/PanelExtended.jsx";
import {FormattedMessage} from "react-intl";
import CloseBtn from "./CloseBtn.jsx";
import TeamDetailsTable from "../Containers/TeamDetailsTableContainer";

const TeamDetailsPanel = ({onHeadToHeadClick, team, game}) => {
    if (!team) {
        return null
    }

    return <div>
        <PanelExtended>
            <PanelHeader className="team-details__header" title={game.name}>
                <Header onHthClick={onHeadToHeadClick} team={team}/>
                <CloseBtn game={game}/>
            </PanelHeader>
            <TeamDetailsTable />
        </PanelExtended>
    </div>
};

const Header = ({team, onHthClick}) =>
    <div className="team-details__header-actions">
        <h3 className="team-details__name">{team.name}</h3>
        {onHthClick ?
            <button className="btn-orange btn-flex-bs" onClick={onHthClick}>
                <FormattedMessage id="hth.title"/>
            </button> : null
        }
    </div>;

export default TeamDetailsPanel